import {ListPage} from "../../common/ListPage";
import {RouteContext} from "../../../RouteContext";
import {Column} from "../../common/Layout";
import {CampaignPolicyIO} from "../../../../io/campaign/campaignPolicyIO";
import {CampaignPolicyValueObject} from "../../../../model/vo/campaign/CampaignPolicyValueObject";
import TruncateText from "../../common/TruncateText";


export default function List(props: RouteContext) {

    return <>
        <Column gap={'16px'}>
            <ListPage
                {...props}
                description={CampaignPolicyValueObject.description}
                list={CampaignPolicyIO.list}
                count={CampaignPolicyIO.count}
                delete={CampaignPolicyIO.delete}
                postHref={'/admin/campaigns/policies/post'}
                detailHref={item => `/admin/campaigns/policies/${item.id}`}
                editHref={item => `/admin/campaigns/policies/edit/${item.id}`}
                itemValue={(item, key) => {
                   if(key === 'isAboveThreshold'){
                        return <div>
                            {item[key] ? 'true(미션페이지)' : 'false(소진페이지)' }
                        </div>
                    }
                    else {
                        return undefined
                    }
                }}
            />
        </Column>
    </>
}